import React, {useEffect, useState} from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import toast, {Toaster} from "react-hot-toast";
import {Backdrop, Box, Fade, Modal} from "@mui/material";

import styles from './AcceptOrderPage.module.scss';
import AddressDetailsOrder from "../../components/AddressDetailsOrder/AddressDetailsOrder";
import PackageDetailsOrder from "../../components/PackageDetailsOrder/PackageDetailsOrder";
import AdditionalInfoOrder from "../../components/AdditionalInfoOrder/AdditionalInfoOrder";
import AddedPhotosCustomerOrder from "../../components/AddedPhotosCustomerOrder/AddedPhotosCustomerOrder";
import coins from "../../constants/images/detailsOrder/coins.svg";
import safe from "../../constants/images/detailsOrder/safe.svg";
import creditCardCheck from "../../constants/images/detailsOrder/credit-card-check.svg";
import {offerActions} from "../../store/slices/offerSlice";
import CustomerShortDetails from "../../components/CustomerShortDetails/CustomerShortDetails";
import {orderActions} from "../../store/slices/orderSlice";
import avatar from '../../constants/images/avatar.svg';
import Loader from "../../components/Loader/Loader";
import {orderService} from "../../services/order.service";
import Support from "../../components/Support/Support";
import {MAIN_ROUTES} from "../../routing/main_routes";
import {offerService} from "../../services/offer.service";
import {resolveMediaUrl} from "../../configs/urls";
import FeedbackPageCleaner from "../FeedbackPageCleaner/FeedbackPageCleaner";
import {qrCodeActions} from "../../store/slices/qrCodeSlice";

const AcceptOrderPage = () => {
    const {pathname, state} = useLocation();
    const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);
    const [triggerIsActiveOrder, setTriggerIsActiveOrder] = useState(false);

    const navigate = useNavigate();

    const dispatch = useDispatch();
    const {offer, status: status1} = useSelector(state => state.offer);
    const {order, status: status2} = useSelector(state => state.order);

    useEffect(() => {
        // get id from url, ex. /accept-order/2, id = 2
        const array = pathname.split('/');
        let id; // getting id from url
        if ((typeof +array[array.length - 1] === "number") && (+array[array.length - 1] !== 0)) {
            id = +array[array.length - 1];
        } else {
            id = +array[array.length - 2];
        }

        const getOfferById = async () => {
            try {
                await dispatch(offerActions.getById({id}));
            } catch (error) {
                toast.error(JSON.stringify(error?.response?.data), {id: "get-offer"});
                console.error(error);
            }
        }

        const getOrderById = async () => {
            try {
                await dispatch(orderActions.getById({id}));
            } catch (error) {
                console.error(error);
            }
        }

        switch (state?.type) {
            case 'offer': {
                getOfferById();
                break;
            }
            case 'order': {
                getOrderById();
                break;
            }
        }
    }, []);

    const handleCreateOrder = async (offerId, requestId) => {
        try {
            const order = {
                offer: offerId,
            }

            await orderService.create(order);
            toast.success(`Замовлення №${requestId} було успішно прийнято!`, {id: "create-order"});
            setTriggerIsActiveOrder(true);
        } catch (error) {
            console.error(error);
            toast.error(JSON.stringify(error?.response?.data), {id: "create-order"});
        } finally {
            // dispatch(orderActions.setStatus('success'));
        }
    }

    const generateQrCode = async () => {
        try {
            await dispatch(qrCodeActions.generate());
        } catch (error) {
            toast.error(JSON.stringify(error?.response?.data), {id: "generate-qr"});
            console.error(error);
        }
    }

    const handleCompleteOrder = async () => {
        await generateQrCode();
        setIsFeedbackModalOpen(true);
    }

    const handleCancelOrder = async (offerId) => {
        try {
            await offerService.deleteById(offerId);
            navigate(MAIN_ROUTES.OFFERS);
        } catch (error) {
            console.error(error)
            toast.error(JSON.stringify(error?.response?.data), {id: "cancel-order"});
        }
    }

    useEffect(() => {
        if (!state) {
            navigate(MAIN_ROUTES.ORDERS);
        }

        return () => {
            toast.remove("get-offer");
            toast.remove("create-order");
            toast.remove("generate-qr");
            toast.remove("cancel-order");
            toast.remove("feedback-cleaner");
        }
    }, [state]);

    if (status1 === 'loading' || status2 === 'loading') {
        return <Loader/>;
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        boxShadow: 24,
        borderRadius: 4
    };

    if (state?.type === 'order') {
        const {offer} = order || {};

        const {cleaner_request, application} = offer || {};

        const {
            pk: id,
            address,
            request_datetime,
            get_total_price,
            cleaning_type,
            room_count,
            pano_window_count,
            reg_window_count,
            wc_count,
            services,
            present_at_home,
            comment,
            present_at_home_desc,
            photos,
            created_on,
            created_by_user,
            service_package,
            request_price
        } = cleaner_request || {}; // to prevent error 'reading of undefined'
        const {application_price} = application || {}; // to prevent error 'reading of undefined'

        return (
            <div className={styles.acceptOrderPage_wrapper}>
                <div className={styles.acceptOrderPage}>
                    <h1 className={styles.acceptOrderPage_title}>Активне замовлення</h1>

                    <div className={styles.acceptOrderPage_content}>
                        <div className={styles.acceptOrderPage_content_leftSide}>
                            <AddressDetailsOrder
                                date={new Date(request_datetime).toLocaleDateString()}
                                address={address}
                                price={null}
                                time={new Date(request_datetime).toLocaleTimeString()}
                            />
                            <PackageDetailsOrder
                                showTitle={true}
                                style={{'padding': '24px 24px 16px 24px', 'borderBottom': '1px solid #D9DBDD'}}
                                selectedPackage={service_package?.name}
                                services={services}
                                countOrdinaryWindows={reg_window_count}
                                countPanoramicWindows={pano_window_count}
                                typeCleaning={cleaning_type}
                                countRooms={room_count}
                                countBathrooms={wc_count}
                            />
                            <CustomerShortDetails
                                photo={resolveMediaUrl(created_by_user?.photos[0]) || avatar}
                                name={created_by_user?.first_name}
                                phone={created_by_user?.mobile_nummer}
                            />
                            <AdditionalInfoOrder
                                isBorderBottom={photos?.length > 0}
                                present_at_home={present_at_home}
                                additionalComments={comment}
                                present_at_home_desc={present_at_home_desc}
                            />
                            {photos?.length > 0 && <AddedPhotosCustomerOrder photos={photos}/>}
                        </div>

                        <div className={styles.acceptOrderPage_content_rightSide}>
                            <div className={styles.acceptOrderPage_content_rightSide_payment}>
                                <p className={styles.acceptOrderPage_content_rightSide_payment_title}>Оплата</p>
                                <div className={styles.acceptOrderPage_content_rightSide_payment_content}>
                                    <div
                                        className={styles.acceptOrderPage_content_rightSide_payment_content_blockContainer}>
                                        <div
                                            className={styles.acceptOrderPage_content_rightSide_payment_content_blockContainer_subtitle}>
                                            <img src={coins} alt="coins icon"/>
                                            <p>Ціна прибирання</p>
                                        </div>
                                        <p>₴ {+application_price}</p>
                                    </div>

                                    <div
                                        className={styles.acceptOrderPage_content_rightSide_payment_content_blockContainer}>
                                        <div
                                            className={styles.acceptOrderPage_content_rightSide_payment_content_blockContainer_subtitle}>
                                            <img src={safe} alt="safe icon"/>
                                            <p>Застраховані кошти</p>
                                        </div>
                                        <p>₴ {+application_price}</p>
                                    </div>

                                    <div
                                        className={styles.acceptOrderPage_content_rightSide_payment_content_blockContainer}>
                                        <div
                                            className={styles.acceptOrderPage_content_rightSide_payment_content_blockContainer_subtitle}>
                                            <img src={creditCardCheck} alt="credit card check icon"/>
                                            <p>Виплачено Клінеру</p>
                                        </div>
                                        <p>₴ 0</p>
                                    </div>
                                </div>

                                <div className={styles.acceptOrderPage_content_rightSide_payment_buttons}>
                                    <button
                                        onClick={handleCompleteOrder}
                                        // onClick={() => navigate(MAIN_ROUTES.PAYMENT, {state: {data: currentOrder, id}})}
                                        className={styles.acceptOrderPage_content_rightSide_payment_buttons_accept}
                                    >Завершити замовлення
                                    </button>
                                </div>
                            </div>

                            <Support/>

                            <Modal
                                aria-labelledby="transition-modal-title"
                                aria-describedby="transition-modal-description"
                                open={isFeedbackModalOpen}
                                onClose={setIsFeedbackModalOpen}
                                closeAfterTransition
                                slots={{backdrop: Backdrop}}
                                slotProps={{
                                    backdrop: {
                                        timeout: 500,
                                    },
                                }}
                            >
                                <Fade in={isFeedbackModalOpen}>
                                    <Box sx={style}>
                                        <FeedbackPageCleaner
                                            handleClose={() => setIsFeedbackModalOpen(false)}
                                            order={offer?.order}
                                        />
                                    </Box>
                                </Fade>
                            </Modal>
                        </div>
                    </div>

                    {/* to appear hot toast notification */}
                    <Toaster/>
                </div>
            </div>
        );
    } else if (triggerIsActiveOrder) {
        const {id: offerId, cleaner_request, application, is_confirmed, order} = offer || {};

        const {
            pk: id,
            address,
            request_datetime,
            get_total_price,
            cleaning_type,
            room_count,
            pano_window_count,
            reg_window_count,
            wc_count,
            services,
            present_at_home,
            comment,
            present_at_home_desc,
            photos,
            created_on,
            created_by_user,
            service_package,
            request_price
        } = cleaner_request || {}; // to prevent error 'reading of undefined'
        const {application_price} = application || {}; // to prevent error 'reading of undefined'

        return (
            <div className={styles.acceptOrderPage_wrapper}>
                <div className={styles.acceptOrderPage}>
                    <h1 className={styles.acceptOrderPage_title}>Активне замовлення</h1>

                    <div className={styles.acceptOrderPage_content}>
                        <div className={styles.acceptOrderPage_content_leftSide}>
                            <AddressDetailsOrder
                                date={new Date(request_datetime).toLocaleDateString()}
                                address={address}
                                price={null}
                                time={new Date(request_datetime).toLocaleTimeString()}
                            />
                            <PackageDetailsOrder
                                showTitle={true}
                                style={{'padding': '24px 24px 16px 24px', 'borderBottom': '1px solid #D9DBDD'}}
                                selectedPackage={service_package?.name}
                                services={services}
                                countOrdinaryWindows={reg_window_count}
                                countPanoramicWindows={pano_window_count}
                                typeCleaning={cleaning_type}
                                countRooms={room_count}
                                countBathrooms={wc_count}
                            />
                            <CustomerShortDetails
                                photo={resolveMediaUrl(created_by_user?.photos[0]) || avatar}
                                name={created_by_user?.first_name}
                                phone={created_by_user?.mobile_nummer}
                            />
                            <AdditionalInfoOrder
                                isBorderBottom={photos?.length > 0}
                                present_at_home={present_at_home}
                                additionalComments={comment}
                                present_at_home_desc={present_at_home_desc}
                            />
                            {photos?.length > 0 && <AddedPhotosCustomerOrder photos={photos}/>}
                        </div>

                        <div className={styles.acceptOrderPage_content_rightSide}>
                            <div className={styles.acceptOrderPage_content_rightSide_payment}>
                                <p className={styles.acceptOrderPage_content_rightSide_payment_title}>Оплата</p>
                                <div className={styles.acceptOrderPage_content_rightSide_payment_content}>
                                    <div
                                        className={styles.acceptOrderPage_content_rightSide_payment_content_blockContainer}>
                                        <div
                                            className={styles.acceptOrderPage_content_rightSide_payment_content_blockContainer_subtitle}>
                                            <img src={coins} alt="coins icon"/>
                                            <p>Ціна прибирання</p>
                                        </div>
                                        <p>₴ {+application_price}</p>
                                    </div>

                                    <div
                                        className={styles.acceptOrderPage_content_rightSide_payment_content_blockContainer}>
                                        <div
                                            className={styles.acceptOrderPage_content_rightSide_payment_content_blockContainer_subtitle}>
                                            <img src={safe} alt="safe icon"/>
                                            <p>Застраховані кошти</p>
                                        </div>
                                        <p>₴ {+application_price}</p>
                                    </div>

                                    <div
                                        className={styles.acceptOrderPage_content_rightSide_payment_content_blockContainer}>
                                        <div
                                            className={styles.acceptOrderPage_content_rightSide_payment_content_blockContainer_subtitle}>
                                            <img src={creditCardCheck} alt="credit card check icon"/>
                                            <p>Виплачено Клінеру</p>
                                        </div>
                                        <p>₴ 0</p>
                                    </div>
                                </div>

                                <div className={styles.acceptOrderPage_content_rightSide_payment_buttons}>
                                    <button
                                        onClick={handleCompleteOrder}
                                        // onClick={() => navigate(MAIN_ROUTES.PAYMENT, {state: {data: currentOrder, id}})}
                                        className={styles.acceptOrderPage_content_rightSide_payment_buttons_accept}
                                    >Завершити замовлення
                                    </button>
                                </div>
                            </div>

                            <Modal
                                aria-labelledby="transition-modal-title"
                                aria-describedby="transition-modal-description"
                                open={isFeedbackModalOpen}
                                onClose={setIsFeedbackModalOpen}
                                closeAfterTransition
                                slots={{backdrop: Backdrop}}
                                slotProps={{
                                    backdrop: {
                                        timeout: 500,
                                    },
                                }}
                            >
                                <Fade in={isFeedbackModalOpen}>
                                    <Box sx={style}>
                                        <FeedbackPageCleaner
                                            handleClose={() => setIsFeedbackModalOpen(false)}
                                            order={offer?.order}
                                        />
                                    </Box>
                                </Fade>
                            </Modal>
                        </div>
                    </div>

                    {/* to appear hot toast notification */}
                    <Toaster/>
                </div>
            </div>
        );
    } else {
        const {id: offerId, cleaner_request, application, is_confirmed, order} = offer || {};

        const {
            pk: id,
            address,
            request_datetime,
            get_total_price,
            cleaning_type,
            room_count,
            pano_window_count,
            reg_window_count,
            wc_count,
            services,
            present_at_home,
            comment,
            present_at_home_desc,
            photos,
            created_on,
            created_by_user,
            service_package,
            request_price
        } = cleaner_request || {}; // to prevent error 'reading of undefined'
        const {application_price} = application || {}; // to prevent error 'reading of undefined'

        return (
            <div className={styles.acceptOrderPage_wrapper}>
                <div className={styles.acceptOrderPage}>
                    <h1 className={styles.acceptOrderPage_title}>Прийняти замовлення</h1>

                    <div className={styles.acceptOrderPage_content}>
                        <div className={styles.acceptOrderPage_content_leftSide}>
                            <AddressDetailsOrder
                                date={new Date(request_datetime).toLocaleDateString()}
                                address={address}
                                price={null}
                                time={new Date(request_datetime).toLocaleTimeString()}
                            />
                            <PackageDetailsOrder
                                showTitle={true}
                                style={{'padding': '24px 24px 16px 24px', 'borderBottom': '1px solid #D9DBDD'}}
                                selectedPackage={service_package?.name}
                                services={services}
                                countOrdinaryWindows={reg_window_count}
                                countPanoramicWindows={pano_window_count}
                                typeCleaning={cleaning_type}
                                countRooms={room_count}
                                countBathrooms={wc_count}
                            />
                            <CustomerShortDetails
                                photo={resolveMediaUrl(created_by_user?.photos[0]) || avatar}
                                name={created_by_user?.first_name}
                            />
                            <AdditionalInfoOrder
                                isBorderBottom={photos?.length > 0}
                                present_at_home={present_at_home}
                                additionalComments={comment}
                                present_at_home_desc={present_at_home_desc}
                            />
                            {photos?.length > 0 && <AddedPhotosCustomerOrder photos={photos}/>}
                        </div>

                        <div className={styles.acceptOrderPage_content_rightSide}>
                            <div className={styles.acceptOrderPage_content_rightSide_payment}>
                                <p className={styles.acceptOrderPage_content_rightSide_payment_title}>Оплата</p>
                                <div className={styles.acceptOrderPage_content_rightSide_payment_content}>
                                    <div
                                        className={styles.acceptOrderPage_content_rightSide_payment_content_blockContainer}>
                                        <div
                                            className={styles.acceptOrderPage_content_rightSide_payment_content_blockContainer_subtitle}>
                                            <img src={coins} alt="coins icon"/>
                                            <p>Ціна прибирання</p>
                                        </div>
                                        <p>₴ {+application_price}</p>
                                    </div>

                                    <div
                                        className={styles.acceptOrderPage_content_rightSide_payment_content_blockContainer}>
                                        <div
                                            className={styles.acceptOrderPage_content_rightSide_payment_content_blockContainer_subtitle}>
                                            <img src={safe} alt="safe icon"/>
                                            <p>Застраховані кошти</p>
                                        </div>
                                        <p>₴ {+application_price}</p>
                                    </div>

                                    <div
                                        className={styles.acceptOrderPage_content_rightSide_payment_content_blockContainer}>
                                        <div
                                            className={styles.acceptOrderPage_content_rightSide_payment_content_blockContainer_subtitle}>
                                            <img src={creditCardCheck} alt="credit card check icon"/>
                                            <p>Виплачено Клінеру</p>
                                        </div>
                                        <p>₴ 0</p>
                                    </div>
                                </div>

                                <div className={styles.acceptOrderPage_content_rightSide_payment_buttons}>
                                    <button
                                        onClick={() => handleCreateOrder(offerId, id)}
                                        // onClick={() => navigate(MAIN_ROUTES.PAYMENT, {state: {data: currentOrder, id}})}
                                        className={styles.acceptOrderPage_content_rightSide_payment_buttons_accept}
                                    >Прийняти замовлення
                                    </button>
                                </div>

                                <button
                                    className={styles.acceptOrderPage_content_rightSide_payment_buttons_reject}
                                    onClick={() => handleCancelOrder(offerId)}
                                >
                                    Відмовитись від замовлення
                                </button>
                            </div>

                            <Modal
                                aria-labelledby="transition-modal-title"
                                aria-describedby="transition-modal-description"
                                open={isFeedbackModalOpen}
                                onClose={setIsFeedbackModalOpen}
                                closeAfterTransition
                                slots={{backdrop: Backdrop}}
                                slotProps={{
                                    backdrop: {
                                        timeout: 500,
                                    },
                                }}
                            >
                                <Fade in={isFeedbackModalOpen}>
                                    <Box sx={style}>
                                        <FeedbackPageCleaner
                                            handleClose={() => setIsFeedbackModalOpen(false)}
                                            order={offer?.order}
                                        />
                                    </Box>
                                </Fade>
                            </Modal>
                        </div>
                    </div>

                    {/* to appear hot toast notification */}
                    <Toaster/>
                </div>
            </div>
        );
    }
};

export default AcceptOrderPage;
